import {SharedColors} from "@fluentui/theme";
import React, {FC} from "react";
import {ListIconButton} from "./ListIconButton";

interface IListItemCheckbox {
    checked?: boolean;
    showUnchecked?: boolean;
    onClick?: (e?: React.MouseEvent<any, any>) => void;
    colored?: boolean;
    disabled?: boolean;
    loading?: boolean;
    title?: string;
    checkedIcon?: string;
    uncheckedIcon?: string;
    relative?: boolean;
}

export const ListItemCheckbox: FC<IListItemCheckbox> = ({
                                                            relative,
                                                            checkedIcon,
                                                            uncheckedIcon,
                                                            title,
                                                            checked,
                                                            showUnchecked,
                                                            colored,
                                                            onClick,
                                                            disabled,
                                                            loading,
                                                        }) => {
    return (
        <ListIconButton
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            color={
                colored
                    ? disabled
                        ? SharedColors.gray10
                        : checked
                            ? SharedColors.green10
                            : SharedColors.red20
                    : undefined
            }
            name={
                checked
                    ? (checkedIcon ?? "CheckMark")
                    : showUnchecked
                        ? (uncheckedIcon ?? "Cancel")
                        : ""
            }
            title={title}
            relative={relative}
        />
    );
};
